import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ReferredComponent() {
    const navigate = useNavigate()
    const location = useLocation()
    useEffect(() => {
        localStorage.setItem("referral_code", location.pathname.split("/")[2])
    }, [location])
    useEffect(() => {
        navigate("/users/register")
    }, [navigate])

    return (
        <></>
    );
}
